import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "builderModalSkeleton",
  "data-test": "skeleton"
}
const _hoisted_2 = {
  class: "builderModalSkeleton_image",
  "data-drag-zone": ""
}

import BuilderModalClose from './BuilderModalClose.vue'

// Один на все модалки: всегда две кнопки-заглушки, «×» активен уже здесь.

export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderModalSkeleton',
  props: {
  showClose: { type: Boolean, default: true }
},
  emits: ['close'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.showClose)
        ? (_openBlock(), _createBlock(BuilderModalClose, {
            key: 0,
            "data-test": "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }))
        : _createCommentVNode("", true)
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"builderModalSkeleton_body\" data-v-7815671a><div class=\"builderModalSkeleton_bar -heading\" data-v-7815671a></div><div class=\"builderModalSkeleton_bar -heading -short\" data-v-7815671a></div><div class=\"builderModalSkeleton_bar\" data-v-7815671a></div><div class=\"builderModalSkeleton_bar\" data-v-7815671a></div><div class=\"builderModalSkeleton_bar -short\" data-v-7815671a></div><div class=\"builderModalSkeleton_buttons\" data-v-7815671a><div class=\"builderModalSkeleton_button -primary\" data-v-7815671a></div><div class=\"builderModalSkeleton_button\" data-v-7815671a></div></div></div>", 1))
  ]))
}
}

})